<template>
	<client-page>

        <sub-visual-full bg="/images/sub/visual/sv4-1.jpg">
            <div class="text-ani-wrap">
                <div class="text-ani mb-14 mb-lg-28">
                    <h2 class="font-weight-bold line-height-1">인재상</h2>
                </div>
                <div class="text-ani">
                    <p class="tit-txt color-grey-d">세일즈웍스는 변하지 않는 핵심가치 PICCCSA와 함께합니다.</p>
                </div>
            </div>
        </sub-visual-full>

        <section class="section">
            <v-container>
                <v-row row--large>
                    <v-col cols="12" sm="6" md="4">
                        <div class="pb-20 pb-lg-30 border-bottom w-100">
                            <div data-aos="fade-left">
                                <h5 class="tit-txt font-weight-bold mb-2 mb-lg-0">
                                    <span class="color-point">P</span>ASSION
                                </h5>
                                <p class="page-text--sm font-weight-bold mb-14 mb-lg-26">
                                    고객사, 동료, 팀원을 향한 열정
                                </p>
                                <p class="page-text--sm color-grey-7 mb-16 mb-lg-30">
                                    열정적이고 목표 지향적인 <br class="d-none d-lg-block">
                                    문화 속에 긍정적인 에너지를 <br class="d-none d-lg-block">
                                    전달합니다.
                                </p>
                            </div>
                            <h2 class="font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1" data-aos="fade-right">P</h2>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="pb-20 pb-lg-30 border-bottom w-100">
                            <div data-aos="fade-left">
                                <h5 class="tit-txt font-weight-bold mb-2 mb-lg-0">
                                    <span class="color-point">I</span>NTEGRITY
                                </h5>
                                <p class="page-text--sm font-weight-bold mb-14 mb-lg-26">
                                    정직
                                </p>
                                <p class="page-text--sm color-grey-7 mb-16 mb-lg-30">
                                    바른 태도로 정직하게 일하며, <br class="d-none d-lg-block">
                                    투명하게 맡은 역할에 <br class="d-none d-lg-block">
                                    최선을 다합니다.
                                </p>
                            </div>
                            <h2 class="font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1" data-aos="fade-right">I</h2>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="pb-20 pb-lg-30 border-bottom w-100">
                            <div data-aos="fade-left">
                                <h5 class="tit-txt font-weight-bold mb-2 mb-lg-0">
                                    <span class="color-point">C</span>OMMUNICATION
                                </h5>
                                <p class="page-text--sm font-weight-bold mb-14 mb-lg-26">
                                    열린 소통과 존중
                                </p>
                                <p class="page-text--sm color-grey-7 mb-16 mb-lg-30">
                                    열린 마음으로 소통하고, <br class="d-none d-lg-block">
                                    편견과 차별 없이 <br class="d-none d-lg-block">
                                    상대방 의견을 존중합니다.
                                </p>
                            </div>
                            <h2 class="font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1" data-aos="fade-right">C</h2>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="pb-20 pb-lg-30 border-bottom w-100">
                            <div data-aos="fade-left">
                                <h5 class="tit-txt font-weight-bold mb-2 mb-lg-0">
                                    <span class="color-point">C</span>HALLENGES
                                </h5>
                                <p class="page-text--sm font-weight-bold mb-14 mb-lg-26">
                                    도전
                                </p>
                                <p class="page-text--sm color-grey-7 mb-16 mb-lg-30">
                                    끊임없는 도전으로 <br class="d-none d-lg-block">
                                    자신의 한계를 뛰어넘고 <br class="d-none d-lg-block">
                                    최상의 결과를 만들어 냅니다. 
                                </p>
                            </div>
                            <h2 class="font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1" data-aos="fade-right">C</h2>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="pb-20 pb-lg-30 border-bottom w-100">
                            <div data-aos="fade-left">
                                <h5 class="tit-txt font-weight-bold mb-2 mb-lg-0">
                                    <span class="color-point">C</span>ELEBRATING
                                </h5>
                                <p class="page-text--sm font-weight-bold mb-14 mb-lg-26">
                                    축하&격려 
                                </p>
                                <p class="page-text--sm color-grey-7 mb-16 mb-lg-30">
                                    성취한 것에 대해 함께 축하하며, <br class="d-none d-lg-block">
                                    상대방의 노력을 인정하고 <br class="d-none d-lg-block">
                                    격려합니다.
                                </p>
                            </div>
                            <h2 class="font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1" data-aos="fade-right">C</h2>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="pb-20 pb-lg-30 border-bottom w-100">
                            <div data-aos="fade-left">
                                <h5 class="tit-txt font-weight-bold mb-2 mb-lg-0">
                                    <span class="color-point">S</span>ELF IMPROVEMENT
                                </h5>
                                <p class="page-text--sm font-weight-bold mb-14 mb-lg-26">
                                    자기계발
                                </p>
                                <p class="page-text--sm color-grey-7 mb-16 mb-lg-30">
                                    잠재력을 최대한 끌어내어 <br class="d-none d-lg-block">
                                    역량을 강화하고 <br class="d-none d-lg-block">
                                    성장합니다. 
                                </p>
                            </div>
                            <h2 class="font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1" data-aos="fade-right">S</h2>
                        </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <div class="pb-20 pb-lg-30 border-bottom w-100">
                            <div data-aos="fade-left">
                                <h5 class="tit-txt font-weight-bold mb-2 mb-lg-0">
                                    <span class="color-point">A</span>CCOUNTABILITY
                                </h5>
                                <p class="page-text--sm font-weight-bold mb-14 mb-lg-26">
                                    책임감
                                </p>
                                <p class="page-text--sm color-grey-7 mb-16 mb-lg-30">
                                    자신의 행동 및 <br class="d-none d-lg-block">
                                    맡은 역할에 <br class="d-none d-lg-block">
                                    책임을 다합니다. 
                                </p>
                            </div>
                            <h2 class="font-size-50 font-size-md-80 font-size-lg-150 font-weight-bold color-point text-right line-height-1" data-aos="fade-right">A</h2>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>
        
	</client-page>
</template>

<script>

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisualFull from "@/components/client/sub/sub-visual-full.vue";

export default{
	components: {
        ClientPage,
        SubVisualFull,
    },
    mounted() {
    },
    data() {
        return {
        }
    },
}
</script>
